module.exports = __webpack_public_path__ + "static/img/Frame600.d04ddff0.png";